
var ajaxEndpoint = '/admin/pins/ajax-new-pin';

module.exports = function RandomPinWidget ($host, config) {

  // DOM
  var $input  = $('[data-pin-output]', $host);
  var $button = $('[data-pin-randomise-trigger]', $host);

  // Functions
  function update (pin) {
    $input.val(pin);
  }

  // Listeners
  $button.on('click', function () {
    fetchJson(
      ajaxEndpoint,
      function (res) { update(res.pin); },
      function (err) { console.error("Error generating new PIN: " + err); }
    );
  });

};

